export default __webpack_public_path__ + "static/media/55-min.5ea4dfac.jpg";